import isEqual from 'lodash/isEqual';

import { ID, SAME_AS_FIRST } from '../components/KPIForm/constants';

export const SET_SERIES = 'SET_SERIES';
export const ADD_SERIES = 'ADD_SERIES';
export const DELETE_SERIES = 'DELETE_SERIES';

export function seriesReducer(state, action) {
  switch (action.type) {
    case DELETE_SERIES:
      return state.filter(({ id }) => !action.payload.includes(id));

    case SET_SERIES:
      const payload = {
        ...action.payload,
        dirty: true,
      };
      const firstRow = state?.[0].id === payload.id;

      let updatedSeries = [];
      if (firstRow) {
        updatedSeries = getUpdatedLinkedSeries(state, payload);
      } else {
        updatedSeries = state.map((item) =>
          item.id !== action.id ? item : payload
        );
      }
      return updatedSeries;

    case ADD_SERIES: {
      return [
        ...state,
        {
          ...action.payload,
          dirty: true,
          id: generateId(),
        },
      ];
    }
  }
}
function getUpdatedLinkedSeries(series = [], editedFirstRowSeries = {}) {
  const [first, ...rest] = series;

  const editedRowKeys = Object.keys(editedFirstRowSeries);
  const updatedRestRowSeries = rest.map((row) => {
    if (row[SAME_AS_FIRST]) {
      const updatedRow = { ...row };
      const rowKeys = Object.keys(row);

      for (const [key, value] of Object.entries(updatedRow)) {
        const firstRowProp = first.hasOwnProperty(key);
        const metricProp = ![ID, SAME_AS_FIRST].includes(key);

        if (firstRowProp && metricProp && isEqual(first[key], value)) {
          updatedRow[key] = editedFirstRowSeries[key];
        }
      }

      if (!isEqual(editedRowKeys, rowKeys)) {
        editedRowKeys.forEach((key) => {
          if (!rowKeys.includes(key)) {
            updatedRow[key] = editedFirstRowSeries[key];
          }
        });
      }

      return updatedRow;
    } else {
      return row;
    }
  });
  return [editedFirstRowSeries, ...updatedRestRowSeries];
}

function generateId() {
  return `${Math.random()}${+new Date()}`;
}
